import Box from 'assets/components/box/Box';
import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import ThemeTagRounded from 'assets/components/tag/themes/Theme.Tag.Rounded';
import { getLocales } from 'assets/locales/Locale';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';
import Theme from 'assets/themes/Theme.Common';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';
import { InsurerAction, useInsurerProvider } from '../Insurer.Hooks';

export default function InsurerList() {
  const { lang } = getLocales();
  const { listApi, pageRouter } = useInsurerProvider();
  const { permissions } = useAuthStore();

  return !listApi.payload && !listApi.isExecuting && listApi.apiCounter > 0 ? (
    <Page
      class={ThemePageError}
      sidebar={<Icon class="fas-clipboard-list" />}
      header={lang.insurers}
      render={lang.noInfo}
    />
  ) : (
    <table className={ThemeTableSimple}>
      <thead>
        <tr>
          <th></th>
          <th>{lang.name}</th>
          <th>{lang.address}</th>
          <th>{lang.products}</th>
          <th data-actions>{lang.actions}</th>
        </tr>
      </thead>
      <tbody>
        <DataMap
          data={listApi.payload?.data}
          render={({ data: insurer }) => (
            <tr key={insurer.id}>
              <td>
                {insurer?.isActive ? (
                  <Box
                    class={ThemeTagRounded}
                    style={{ color: Theme.Color.success, backgroundColor: Theme.Color.successLight }}
                  >
                    <Icon class="fas-check" />
                    &nbsp; {lang.active}
                  </Box>
                ) : (
                  <Box
                    class={ThemeTagRounded}
                    style={{ color: Theme.Color.error, backgroundColor: Theme.Color.errorLight }}
                  >
                    <Icon class="fas-ban" />
                    &nbsp; {lang.inactive}
                  </Box>
                )}
              </td>
              <td>
                <b>{insurer.name}</b>
              </td>
              <td>{insurer.fullAddress}</td>
              <td>
                {insurer.products.length ?? 0} {lang.products}
              </td>
              <td>
                <Box class={ThemeWrapperStack}>
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: insurer.id.toString(),
                      action: InsurerAction.EDIT,
                    }}
                    disabled={!permissions.EDIT_LOSSCODE}
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-edit" />}
                    htmlElementProps={{ title: lang.edit }}
                    active
                  />
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: insurer.id.toString(),
                      action: InsurerAction.DELETE,
                    }}
                    disabled={!permissions.DELETE_LOSSCODE}
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-trash" />}
                    htmlElementProps={{ title: lang.delete }}
                    active
                  />
                </Box>
              </td>
            </tr>
          )}
        />
      </tbody>
    </table>
  );
}
